export const CLINIC = {
  name: "Aarogya Clinic",
  tagline: "Your Family's Trusted Healthcare Partner for Over 35 Years",
  doctor: {
    name: "Dr. V. K. Onkar",
    quals: "MBBS, D.I.H., AFIH",
    role: "Consultant Physician",
    experience: "35+ Years Clinical Experience",
    former: "Former Assistant General Manager (Medical), BHEL Bhopal",
    languages: ["English", "Hindi"],
    photo:
      "https://customer-assets.emergentagent.com/job_web-builder-2529/artifacts/s7f7rnnx_3597FACF-0037-44DF-B1B7-9DC010FD3BB3.png",
  },
  address: {
    line1: "Shop No. 18, Eco Green Park",
    line2: "Ayodhya Bypass Road",
    city: "Bhopal",
    pin: "462041",
    state: "Madhya Pradesh, India",
  },
  phoneDisplay: "+91 96304 19685",
  phoneTel: "+919630419685",
  whatsapp: "919630419685",
  email: "contact@aarogyaclinic.in",
  hours: [
    { day: "Mon – Sat", evening: "5:00 PM – 8:00 PM" },
    { day: "Sunday", evening: "By Appointment Only" },
  ],
  mapsQuery:
    "Aarogya Clinic, Shop 18, Eco Green Park, Ayodhya Bypass Road, Bhopal 462041",
};

export const waLink = (msg = "") =>
  `https://wa.me/${CLINIC.whatsapp}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;

export const telLink = () => `tel:${CLINIC.phoneTel}`;
